import { render, staticRenderFns } from "./PasswordInputExtended.vue?vue&type=template&id=0608165c&scoped=true&lang=pug"
import script from "./PasswordInputExtended.vue?vue&type=script&lang=ts"
export * from "./PasswordInputExtended.vue?vue&type=script&lang=ts"
import style0 from "./PasswordInputExtended.vue?vue&type=style&index=0&id=0608165c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0608165c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
